import {ALL_DOMAIN_LIST} from '../../../config';
import {ApiService} from '../../services/api.service';
import {Injectable} from '@angular/core';

@Injectable()
export class Common {
  domanList = [];

  constructor(private apiService: ApiService) {
  }

  getDomainList() {
    this.apiService
      .get(ALL_DOMAIN_LIST)
      .subscribe((result) => {
        this.domanList.push({
          'name': 'All',
          'value': 'All'
        });
        for (let i = 0; i < result['data'].length; i++) {
          this.domanList.push({
            'name': result['data'][i]['domain'],
            'value': result['data'][i]['domain']
          });
        }
      });
  }
}
